import { Button } from "../ui/button";
import { CheckCircle, Phone } from "lucide-react";

export const QuoteSuccess = () => (
  <div data-testid="quote-success" className="min-h-screen pt-24 pb-16 bg-brand-ice">
    <div className="max-w-2xl mx-auto px-6 md:px-12 text-center">
      <div className="bg-white rounded-sm border border-border p-12">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-green-600" />
        </div>
        <h1 className="font-heading text-4xl font-bold uppercase text-brand-navy mb-4">
          Thank You!
        </h1>
        <p className="text-lg text-brand-slate mb-8">
          Your quote request has been submitted successfully. Our team will
          review your project details and contact you within 24-48 hours.
        </p>
        <div className="bg-brand-ice rounded-sm p-6 text-left">
          <h3 className="font-heading font-bold text-brand-navy uppercase mb-4">
            What happens next?
          </h3>
          <ul className="space-y-3 text-brand-slate">
            {["Our team reviews your project requirements",
              "We'll reach out to schedule a consultation",
              "Receive a detailed proposal and quote"].map((text, i) => (
              <li key={text} className="flex items-start gap-3">
                <span className="w-6 h-6 bg-brand-orange rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                  {i + 1}
                </span>
                {text}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 mt-8">
          <Button
            onClick={() => (window.location.href = "/")}
            variant="outline"
            className="flex-1 border-2 border-brand-navy text-brand-navy font-heading font-bold uppercase hover:bg-brand-navy hover:text-white"
          >
            Return Home
          </Button>
          <Button
            onClick={() => (window.location.href = "tel:+0000000000")}
            className="flex-1 bg-brand-orange text-white font-heading font-bold uppercase hover:bg-brand-orange/90"
          >
            <Phone className="w-4 h-4 mr-2" />
            Call Us Now
          </Button>
        </div>
      </div>
    </div>
  </div>
);
